import { render, staticRenderFns } from "./riskDevices.vue?vue&type=template&id=44836a59"
import script from "./riskDevices.vue?vue&type=script&lang=js"
export * from "./riskDevices.vue?vue&type=script&lang=js"
import style0 from "./riskDevices.vue?vue&type=style&index=0&id=44836a59&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44836a59')) {
      api.createRecord('44836a59', component.options)
    } else {
      api.reload('44836a59', component.options)
    }
    module.hot.accept("./riskDevices.vue?vue&type=template&id=44836a59", function () {
      api.rerender('44836a59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/riskDevices.vue"
export default component.exports